<!-- shopy Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>
<div
  class="collecting-header"
  style="background-image: url(assets/image/Group-1895.png);">
  <div class="collecting-head">
    <div class="head">
      <h3>COLLECTING BASICS</h3>
    </div>
  </div>
</div>

<!-- collections details -->
<div class="container">
    <div class="collection-items">
        <div class="row">
            <ng-template ngFor let-item [ngForOf]="data" >
            <div class="col-lg-4 col-md-6 collections">
                <div class="collection-elements">
                    <div class="coll-image">
                        <img src="{{item.art_image}}">
                    </div>
                    <div class="coll-detials">
                        <h2>{{item.art_head}}</h2>
                        <p class="text">{{item.art_details}}</p>

                    </div>
                    <div class="coll-btn-item">
                        <a   [routerLink]="['/collectiondetails',item.art_id]"  class="coll-btn">Read More</a>
                    </div>
                    <!-- <div class="date-cmds">
                        <div class="row">
                            <div class="col-12 text-left">
                                <i class="fa fa-calendar" aria-hidden="true"></i> {{item.art_date}}
                            </div>
                            
                        </div>
                    </div> -->
                </div>
            </div>
            </ng-template>

        </div>
          <!-- pagination -->
  <div class="event-pagination">
    <div class="container">
      <div class="pagination-items">
        <div class="elements">
            <a   [routerLink]="['/collection/',1]"   class="pag-btn">
              <i  class="fa fa-angle-double-left" aria-hidden="true"></i>
            </a>
            <ng-template [ngIf]="previous">
            <a  [routerLink]="['/collection/',previous]"    class="pag-btn">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </a>
            </ng-template>
            <span>
              <a  class="pag-item-previous"> PREVIOUS</a>
              <a class="pag-item-next"> NEXT </a>
            </span>
            <ng-template [ngIf]="next">
            <a   [routerLink]="['/collection/',next]"  class="pag-btn">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </a>
        </ng-template>
            <a   [routerLink]="['/collection/',last]"   class="pag-btn">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </div>
      </div>
    </div>
  </div>
    </div>
</div>

<app-contactform></app-contactform>